// Python API Endpoints

import { BASE_URL, pythonBaseUrl } from "../App_Settings/app_settings";
import { v4 as uuidv4 } from "uuid";
import { importFileData } from "../services/fileDataService";
//Upload File API Endpoint
export const uploadFile = "uploadFile";

//Upload File To AZURE-AI API Endpoint
export const uploadFileToAZUREAI = "Azure-Upload-File";

// Method to retrieve userId from localStorage
export const getUserIdFromLocalStorage = () => {
  const userDataJSON = localStorage.getItem("token");
  if (!userDataJSON) {
    throw new Error("No token found in localStorage");
  }

  const userData = JSON.parse(userDataJSON);
  const userId = userData?.userId;
  if (!userId) {
    throw new Error("userId is a mandatory field and cannot be empty.");
  }

  return userData;
};

export const getFileAuditById = async (fileId) => {
  try {
    const response = await fetch(`${BASE_URL}/AuditLog/FileAudit?fileId=${fileId}`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${getUserIdFromLocalStorage().token}`,
      },
    });
    if (!response.ok) {
      throw new Error(`Error: ${response.status}`);
    }
    const data = await response.json();

    if (Array.isArray(data)) {
      return data; // Expected array
    }
    // return data; // Process the data as needed
  } catch (error) {
    console.error("Error fetching file audit:", error);
  }
};

export const getUserFileAuditByUserId = async (
  customUserId = null,
  customOrganizationId = null
) => {
  // Use custom parameters if provided, otherwise retrieve from localStorage
  const userId = customUserId || getUserIdFromLocalStorage().userId;
  const organizationId = customOrganizationId || getUserIdFromLocalStorage().organizationId;

  // Check if userId is provided
  if (!userId) {
    throw new Error("userId is a mandatory field and cannot be empty.");
  }

  try {
    // First, get user role to determine which endpoint to use
    const userResponse = await fetch(`${BASE_URL}/users/${userId}/${organizationId}`, {
      headers: {
        Authorization: `Bearer ${getUserIdFromLocalStorage().token}`,
      },
    });

    let isAdminUser = false;
    if (userResponse.ok) {
      const user = await userResponse.json();
      if (user) {
        // Check if user is super admin or has admin role
        const isSuperAdmin = user.isSuperAdmin;
        const userRoles = user.userRoles || [];
        const hasAdminRole = userRoles.some((role) => role.name === "Admin");
        isAdminUser = hasAdminRole;
      }
    }

    // Choose endpoint based on user role
    let endpoint;
    if (isAdminUser) {
      // Admin or Super Admin - use organization audit log
      endpoint = `${BASE_URL}/AuditLog/OranganizationFileAudit?oranganizationId=${organizationId}`;
    } else {
      // Normal user - use user audit log
      endpoint = `${BASE_URL}/AuditLog/UserFileAudit?userId=${userId}`;
    }

    const response = await fetch(endpoint, {
      method: "GET",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${getUserIdFromLocalStorage().token}`,
      },
    });

    if (!response.ok) {
      throw new Error(`Error: ${response.status}`);
    }
    const data = await response.json();
    // For each item, determine action and actionDate, and return the required columns
    return Array.isArray(data)
      ? data.map((item) => {
          let action = null;
          let actionDate = null;
          if (item.uploadDate) {
            action = "Uploaded";
            actionDate = item.uploadDate;
          } else if (item.extractedDate) {
            action = "Extracted";
            actionDate = item.extractedDate;
          } else if (item.approvedDate) {
            action = "Approved";
            actionDate = item.approvedDate;
          } else if (item.rejectedDate) {
            action = "Rejected";
            actionDate = item.rejectedDate;
          } else if (item.exportedDate) {
            action = "Exported";
            actionDate = item.exportedDate;
          } else if (item.deletedDate) {
            action = "Deleted";
            actionDate = item.deletedDate;
          }
          return {
            fileName: item.fileName,
            userName: item.userName,
            email: item.email,
            action: action,
            actionDate: actionDate,
          };
        })
      : [];
  } catch (error) {
    console.error("Error fetching user file audit:", error);
    return [];
  }
};

export const logFileChanges = async ({
  fileImportId,
  dataType,
  fieldName,
  oldValue,
  newValue,
  action,
  modifiedBy,
  uid,
}) => {
  // Validate required fields
  if (!fileImportId || !dataType || !fieldName || !action || !modifiedBy) {
    console.error("Missing required fields for logFileChanges:", {
      fileImportId,
      dataType,
      fieldName,
      action,
      modifiedBy,
    });
    return { success: false, error: "Missing required fields" };
  }

  const fileChangesData = {
    fileImportId,
    dataType,
    fieldName,
    oldValue: oldValue || "",
    newValue: newValue || "",
    action,
    modifiedBy,
    uid: uid || "",
  };

  const maxRetries = 3;
  let retryCount = 0;

  while (retryCount < maxRetries) {
    try {
      const response = await fetch(`${BASE_URL}/AuditLog/ImportFileChangesLog`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${getUserIdFromLocalStorage().token}`,
        },
        body: JSON.stringify(fileChangesData),
      });

      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(`HTTP ${response.status}: ${errorText}`);
      }

      const data = await response.json();
      return { success: true, data };
    } catch (error) {
      retryCount++;
      console.error(`Error logging file changes (attempt ${retryCount}/${maxRetries}):`, error);

      if (retryCount < maxRetries) {
        // Wait before retrying (exponential backoff)
        const delay = Math.pow(2, retryCount) * 1000; // 2s, 4s, 8s
        await new Promise((resolve) => setTimeout(resolve, delay));
      } else {
        return { success: false, error: error.message };
      }
    }
  }
};
//new Date()
export const logFileProcess = async ({
  fileName,
  fileImportId,
  uploadDate,
  extractedDate,
  approvedDate,
  rejectedDate,
  exportedDate,
  deletedDate,
}) => {
  // Retrieve userId from localStorage
  const userId = getUserIdFromLocalStorage().userId;
  const organizationId = getUserIdFromLocalStorage().organizationId;

  // Check if userId is provided
  if (!userId) {
    throw new Error("userId is a mandatory field and cannot be empty.");
  }
  // Check if userId is provided
  if (!fileImportId) {
    throw new Error("fileId is a mandatory field and cannot be empty.");
  }
  const fileProcessData = {
    userId,
    organizationId,
    fileName,
    fileImportId,
    uploadDate,
    extractedDate,
    approvedDate,
    rejectedDate,
    exportedDate,
    deletedDate,
  };
  try {
    const response = await fetch(`${BASE_URL}/AuditLog/ImportFileProcessLog`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${getUserIdFromLocalStorage().token}`,
      },
      body: JSON.stringify(fileProcessData),
    });
    if (!response.ok) {
      throw new Error(`Error: ${response.status}`);
    }
    const data = await response.json();
    return data; // Process the response as needed
  } catch (error) {
    console.error("Error logging file process:", error);
  }
};

const generateUUID = () => {
  const newUUID = uuidv4(); // Generate a new UUID
  return newUUID;
};

export const uploadPreLoadedFiles = async () => {
  try {
    // Add a flag to prevent concurrent executions
    if (window._isUploadingPreloadedFiles) {
      return;
    }
    window._isUploadingPreloadedFiles = true;

    // Retrieve userId from localStorage
    const userId = getUserIdFromLocalStorage().userId;
    const userName = `${getUserIdFromLocalStorage().firstName} ${
      getUserIdFromLocalStorage().lastName
    }`;

    // Check user audit length; if 0, add sample files
    const userAudit = await getUserFileAuditByUserId(userId);

    // Check if any of the sample files already exist
    const existingFiles = userAudit.map((audit) => audit.fileName);

    // Early return if user already has files
    if (userAudit.length > 0) {
      window._isUploadingPreloadedFiles = false;
      window._isUploadingPreloadedFiles = false;
      return;
    }

    // Add sample files if no audit data exists
    const sampleFiles = [
      // { name: "WHS Example 1.pdf", fileId: generateUUID() },
      { name: "WHS Example.pdf", fileId: generateUUID() },
      // { name: "WHS Example 3.pdf", fileId: generateUUID() },
      { name: "Pack Example.pdf", fileId: generateUUID() },
    ];

    for (const sampleFile of sampleFiles) {
      // Skip if file already exists
      if (existingFiles.includes(sampleFile.name)) {
        continue;
      }

      try {
        // Double-check if file was uploaded during processing
        const currentAudit = await getUserFileAuditByUserId(userId);
        if (currentAudit.some((audit) => audit.fileName === sampleFile.name)) {
          continue;
        }

        // Prepare form data for file upload
        const formData = new FormData();
        formData.append("original_filename", sampleFile.name);
        formData.append("filename", sampleFile.fileId);
        formData.append("organizationId", getUserIdFromLocalStorage().organizationId);
        formData.append("userId", getUserIdFromLocalStorage().userId);
        formData.append("isPreUploaded", true);
        const uploadResponse = await fetch(`${pythonBaseUrl}/File/UploadFile`, {
          method: "POST",
          headers: {
            Authorization: `Bearer ${getUserIdFromLocalStorage().token}`,
          },
          body: formData,
        });

        if (!uploadResponse.ok) {
          console.error(`Failed to upload file ${sampleFile.name}`);
          continue;
        }

        const newRow = {
          fileImportId: sampleFile.fileId,
          userId: userId,
          fileName: sampleFile.name,
          filePath: "",
          prcoessIdentifier: "AZURE-AI",
          isProcessed: false,
          businessUnit: "Demo",
          uploadedBy: userName,
          uploadedDate: new Date().toISOString(),
          reviewedBy: null,
          uploadType: sampleFile.name.includes("Pack") ? "11" : "1",
          reviewedDate: null,
          numberOfFields: null,
          confidenceLevel: null,
          approvedBy: null,
          approvedDate: null,
          emailedTo: null,
          emailedDate: null,
          isInvestment: false,
          rejectedBy: null,
          isWithholding: true,
          numberOfRows: null,
          numberOfTiers: null,
          status: null,
          accuracyPercentage: null,
          rejectionReason: "",
          notes: "",
        };

        // Import file data using centralized service
        const importResult = await importFileData([newRow]);

        if (!importResult.success) {
          console.error(`Failed to import file data for ${sampleFile.name}`);
          continue;
        }

        // Log successful file process
        await logFileProcess({
          fileId: sampleFile.fileId,
          fileName: sampleFile.name,
          uploadDate: new Date(),
        });
      } catch (error) {
        console.error(`Error processing file ${sampleFile.name}:`, error.message);
        continue;
      }
    }
  } catch (error) {
    console.error("Error in uploadPreLoadedFiles:", error.message);
  } finally {
    window._isUploadingPreloadedFiles = false;
  }
};

const fileChangesData = {
  fileImportId: "UUID",
  dataType: "string",
  fieldName: "string",
  oldValue: "string",
  newValue: "string",
  action: "string",
  modifiedBy: "string",
};
const fileProcessData = {
  userId: "UUID",
  fileName: "string",
  fileId: "UUID",
  uploadDate: "2024-01-10T12:00:00Z",
  extractedDate: "2024-01-11T12:00:00Z",
  approvedDate: "",
  rejectedDate: "",
  exportedDate: "",
  deletedDate: "",
};

export const generateReport = async (reportData) => {
  // Create a new FormData object
  const formData = new FormData();

  // Append the report data
  formData.append("reportData", JSON.stringify(reportData));
  formData.append("organizationId", getUserIdFromLocalStorage().organizationId);
  formData.append("userId", getUserIdFromLocalStorage().userId);
  formData.append("businessUnit", "Demo");

  // Set the URL for the Python-based report generation API
  const url = `${pythonBaseUrl}/Excel/ExcelReport`;

  // Start the fetch request to the API
  return fetch(url, {
    method: "POST",
    body: formData, // Include the FormData object as the request body
  })
    .then((response) => {
      // Check if the response is OK
      if (response.ok) {
        // Handle successful response
        const downloadLink = document.createElement("a");
        downloadLink.href = "https://eformapi.complytaxforms.com/p/s/report.xlsx"; // URL of the Excel file to download
        downloadLink.setAttribute("download", "report.xlsx"); // Specify the desired file name for download
        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);
      } else {
        // Handle the error if the response is not OK
        console.error("Failed to generate the report");
      }
    })
    .catch((error) => {
      // Handle any network errors
      console.error("Error during fetch:", error);
    });
};

// Centralized getReport function with role-based endpoint selection
export const getReport = async (defaultUser, defaultOrganization) => {
  try {
    const userId = getUserIdFromLocalStorage().userId;
    const organizationId = getUserIdFromLocalStorage().organizationId;

    // First, get user role to determine which endpoint to use
    const userResponse = await fetch(`${BASE_URL}/users/${userId}/${organizationId}`, {
      headers: {
        Authorization: `Bearer ${getUserIdFromLocalStorage().token}`,
      },
    });

    let isAdminUser = false;
    if (userResponse.ok) {
      const user = await userResponse.json();
      if (user) {
        const userRoles = user.userRoles || [];
        const hasAdminRole = userRoles.some((role) => role.name === "Admin");
        isAdminUser = hasAdminRole;
      }
    } else {
      console.warn("Failed to fetch user role, using default behavior");
    }

    // Helper function to get appropriate report endpoint based on user role and default selections
    const getReportEndpoint = () => {
      if (defaultUser && defaultUser.id) {
        const userIdValue = defaultUser.id;
        if (!userIdValue || userIdValue === "undefined" || userIdValue === "null") {
          throw new Error("Invalid defaultUser.userId value");
        }
        return `${BASE_URL}/FileImportReport/UserReport/${userIdValue}`;
      }
      // Check if defaultOrganization is selected (admin is viewing organization data)
      else if (defaultOrganization && defaultOrganization.id) {
        const orgIdValue = defaultOrganization.id;
        if (!orgIdValue || orgIdValue === "undefined" || orgIdValue === "null") {
          throw new Error("Invalid defaultOrganization.organizationId value");
        }
        return `${BASE_URL}/FileImportReport/OrganizationReport/${orgIdValue}`;
      }
      // Default behavior based on user role
      else if (isAdminUser) {
        if (!organizationId || organizationId === "undefined" || organizationId === "null") {
          throw new Error("Invalid organizationId value for admin user");
        }
        return `${BASE_URL}/FileImportReport/OrganizationReport/${organizationId}`;
      } else {
        // Fix: Use consistent property name (userId instead of userID)
        if (!userId || userId === "undefined" || userId === "null") {
          throw new Error("Invalid userId value for normal user");
        }
        return `${BASE_URL}/FileImportReport/UserReport/${userId}`;
      }
    };

    const endpoint = getReportEndpoint();

    const response = await fetch(endpoint, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${getUserIdFromLocalStorage().token}`,
        accept: "*/*",
      },
    });

    if (response.status === 401) {
      return { success: false, error: "Unauthorized" };
    }

    // Handle 404 as valid empty state (no reports found)
    if (response.status === 404) {
      return { success: true, data: [] };
    }

    if (!response.ok) {
      const errorText = await response.text();
      console.error(`API Error ${response.status}:`, errorText);
      throw new Error(`Failed with status: ${response.status}, Details: ${errorText}`);
    }

    const data = await response.json();

    return { success: true, data };
  } catch (error) {
    console.error("Failed to retrieve report:", error);
    return { success: false, error };
  }
};

export const getFileBytes = async (
  organizationId,
  userId,
  fileImportId,
  filename,
  extension,
  type,
  businessunit
) => {
  try {
    if (!organizationId || !userId || fileImportId == null || !filename) {
      throw new Error("organizationId, userId, fileImportId, and filename are required parameters");
    }

    const userData = getUserIdFromLocalStorage();

    const requestData = {
      organizationId: organizationId,
      userId: userId,
      fileImportId: fileImportId,
      filename: filename,
      extension: extension || "",
      type: type || "",
      businessunit: businessunit || "",
    };

    const response = await fetch(`${pythonBaseUrl}/File/GetFileBytes`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${userData.token}`,
        Accept: "application/octet-stream",
      },
      body: JSON.stringify(requestData),
    });

    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(`Failed to fetch file bytes: ${response.status} - ${errorText}`);
    }

    // Get the content type from response headers
    const contentType = response.headers.get("content-type") || "application/octet-stream";

    // Get file bytes as ArrayBuffer
    const arrayBuffer = await response.arrayBuffer();

    // Validate that we actually have file data
    if (arrayBuffer.byteLength === 0) {
      throw new Error("Received empty file data from server");
    }

    return {
      fileBytes: arrayBuffer,
      mimeType: contentType,
      filename: filename,
      extension: extension,
    };
  } catch (error) {
    console.error("Error fetching file bytes:", error);
    throw error;
  }
};

export const getExcelFile = async (organizationId, userId, businessUnit, fileImportId) => {
  try {
    if (!organizationId || !userId || !businessUnit || fileImportId == null) {
      throw new Error(
        "organizationId, userId, businessUnit, and fileImportId are required parameters"
      );
    }

    const userData = getUserIdFromLocalStorage();

    const requestData = {
      organizationId: organizationId,
      userId: userId,
      businessUnit: businessUnit,
      fileImportId: fileImportId,
    };

    const response = await fetch(`${pythonBaseUrl}/File/GetExcelFile`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${userData.token}`,
        Accept: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      },
      body: JSON.stringify(requestData),
    });

    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(`Failed to fetch Excel file: ${response.status} - ${errorText}`);
    }

    // Get the content disposition header for filename
    const contentDisposition = response.headers.get("Content-Disposition");
    let filename = `export_${fileImportId}.xlsx`; // Default filename

    if (contentDisposition) {
      const filenameMatch = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
      if (filenameMatch && filenameMatch[1]) {
        filename = filenameMatch[1].replace(/['"]/g, "");
      }
    }

    // Get file as blob
    const blob = await response.blob();

    // Validate that we actually have file data
    if (blob.size === 0) {
      throw new Error("Received empty Excel file from server");
    }

    // Create download link and trigger download
    const downloadUrl = window.URL.createObjectURL(blob);
    const downloadLink = document.createElement("a");
    downloadLink.href = downloadUrl;
    downloadLink.download = filename;

    // Append to body, click, and remove
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);

    // Clean up the object URL
    window.URL.revokeObjectURL(downloadUrl);

    return {
      success: true,
      filename: filename,
      size: blob.size,
      message: `Excel file downloaded successfully: ${filename}`,
    };
  } catch (error) {
    console.error("❌ Error downloading Excel file:", error);
    throw error;
  }
};

export const deleteFile = async (
  organizationId,
  userId,
  fileImportId,
  fileFormat,
  businessUnit = null
) => {
  try {
    // Validate required parameters
    if (!organizationId || !userId || !fileImportId || !fileFormat) {
      throw new Error(
        "organizationId, userId, fileImportId, and fileFormat are required parameters"
      );
    }

    const userData = getUserIdFromLocalStorage();

    // Build query parameters
    const params = new URLSearchParams({
      organization_id: organizationId,
      user_id: userId,
      file_import_id: fileImportId,
      file_format: fileFormat,
    });

    // Add businessUnit if provided
    if (businessUnit) {
      params.append("business_unit", businessUnit);
    }

    const response = await fetch(`${pythonBaseUrl}/File/DeleteFileWithRelated?${params}`, {
      method: "DELETE",
      headers: {
        Authorization: `Bearer ${userData.token}`,
        Accept: "application/json",
      },
    });

    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(`Failed to delete file: ${response.status} - ${errorText}`);
    }

    const data = await response.json();

    return {
      success: true,
      data: data,
      message: "File deleted successfully",
    };
  } catch (error) {
    console.error("❌ Error deleting file:", error);
    throw error;
  }
};
